<nav class="navbar navbar-expand-lg navbar-light bg-light-top fixed-top">
  <div class="container-fluid px-4">
    <a class="navbar-brand" href="#">
      <img src="assets/img/gtn-logo-embed.svg" height="auto" alt="GTN" loading="lazy" class="desktop-logo" />
    </a>
    <!-- <button class="navbar-toggler" type="button" (click)="basicNav.toggle()" aria-expanded="false"
      aria-label="Toggle navigation" data-bs-toggle="collapse" data-bs-target="#navbarNav">
      <span class="navbar-toggler-icon"></span>
    </button> -->
    <div *ngIf=" !isLoggedIn">
      <button type="button" (click)="login()" class="navbar-toggler gtn-register-top-nav ms-2 login-btn">Sign
        in</button>
      <a href="/registration" (click)="openRegistration($event)" class="navbar-toggler gtn-register-top-nav ms-3" type="button">Register</a>
    </div>

    <div class="collapse navbar-collapse ms-2" id="navbarNav" mdbCollapse #basicNav="mdbCollapse">
      <ul class="navbar-nav">

        <li [hidden]="userType !== 'FEED' || !isLoggedIn" class="nav-item"
          [ngClass]="activePage == 'rest-api-reference' ? 'active' : ''">
          <a class="nav-link" [href]="'/feed-api-reference#/5568fcc2e1323-authentication'">API Reference</a>
        </li>

        <li [hidden]="userType === 'FEED' || !isLoggedIn || (!isRestAPIEnabled && !isEmbedAPIEnabled)"
          class="nav-item apis-menu-wrapper" #apisMenuContainer>
          <button type="button" class="nav-link apis-menu-toggle"
            [ngClass]="{ active: isApiPageActive, open: isApisMenuOpen }" (click)="toggleApisMenu()">
            {{ selectedApiLabel }}
            <svg class="apis-caret" width="10" height="6" viewBox="0 0 10 6" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>

          <div class="apis-mega-panel" *ngIf="isApisMenuOpen">
            <a *ngIf="isRestAPIEnabled" class="apis-mega-item" href="/doc/trade/1.2.1/getting-started/introduction" [ngClass]="{ active: activePage == 'rest-api-reference' }">
              <span class="apis-mega-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5" />
                  <path d="M3 12h18M12 3c2.5 2.6 3.8 5.7 3.8 9S14.5 18.4 12 21c-2.5-2.6-3.8-5.7-3.8-9S9.5 5.6 12 3Z"
                    stroke="currentColor" stroke-width="1.5" />
                </svg>
              </span>
              <span class="apis-mega-text">
                <span class="apis-mega-title">Trade API</span>
                <span class="apis-mega-desc">Real-time multi-asset trading via REST</span>
              </span>
            </a>

            <a *ngIf="isEmbedAPIEnabled" class="apis-mega-item" href="/doc/microinvest/1.1.0/guides/getting-started" [ngClass]="{ active: activePage == 'microinvest-api' }">
              <span class="apis-mega-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 19V10M10 19V5M16 19v-6" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round" />
                  <circle cx="20" cy="8" r="2.2" stroke="currentColor" stroke-width="1.5" />
                </svg>
              </span>
              <span class="apis-mega-text">
                <span class="apis-mega-title">Microinvest API</span>
                <span class="apis-mega-desc">Fractional and micro-investing integration</span>
              </span>
            </a>

            <a *ngIf="isEmbedAPIEnabled" class="apis-mega-item" href="/doc/invest/1.0.0/apis/authentication/get-server-token" [ngClass]="{ active: activePage == 'invest-api' }">
              <span class="apis-mega-icon">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" stroke-width="1.5" />
                  <path d="M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7M3 12h18" stroke="currentColor"
                    stroke-width="1.5" />
                </svg>
              </span>
              <span class="apis-mega-text">
                <span class="apis-mega-title">Invest API</span>
                <span class="apis-mega-desc">Portfolio and wealth management services</span>
              </span>
            </a>
          </div>
        </li>
      </ul>
      <div class="navbar-nav ms-auto">
        <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center text-center">
          <!-- <div *ngIf="isLoggedIn">
            <div class="hstack gap-3">
              <div *ngIf="!isInitialLogin && oms" class="position-relative text-center">
                <a class="nav-link d-flex align-items-center" href="/dashboard/user-profile">
                  <img src="/assets/img/avatar.png" class="img-thumbnail rounded-circle" alt="avatar"
                    style="width: 45px" />
                  <span class="user-name ms-2">{{ this.user.username }}</span>
                </a>
              </div>
              <div>
                <button type="button" (click)="logout()" class="btn btn-outline ms-2 login-btn">
                  Log out
                </button>
              </div>
            </div>
          </div> -->
          <!-- Shared Avatar + Drawer (Mobile and Desktop) -->


          <div *ngIf=" !isLoggedIn && userType==='OMS'" class=" text-center">
            <!-- <a href="/registration" class="btn btn-outline-success btn-round" type="button">Get Started</a> -->
            <button type="button" (click)="login()" class="ms-2 gtn-register-top-nav">
              Sign In
            </button>
            <a href="/registration" (click)="openRegistration($event)" class="gtn-register-top-nav ms-3" type="button">Register</a>
          </div>
          <div *ngIf="!isLoggedIn && userType === 'FEED'" class="text-center">
            <a href="/login/user-login" class="gtn-register-top-nav ms-3">Log in</a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isLoggedIn && !isInitialLogin && oms" #profileContainer class="user-menu-wrapper">
      <!-- Avatar -->
      <div class="avatar-circle" (click)="toggleDrawer()">
        {{ getInitials(user?.username) }}
      </div>

      <!-- Dropdown -->
      <div class="user-dropdown-card" *ngIf="isDrawerOpen">
        <div class="user-email">
          {{ user?.username }}
        </div>

        <div class="user-actions">
          <button class="action-btn" (click)="logout()">Sign Out</button>

          <a routerLink="/dashboard/user-profile" class="action-btn" (click)="isDrawerOpen=false">
            Settings
          </a>
        </div>
      </div>
    </div>
  </div>

</nav>

<!-- Maintenance Notification -->
<!-- <app-maintenance-notification *ngIf="isLoggedIn"></app-maintenance-notification> -->

<!-- Mobile API Bar -->
<div class="mobile-api-bar-container d-lg-none" *ngIf="isLoggedIn">
  <!-- Left Scroll Button -->
  <button class="scroll-btn left" *ngIf="showLeftArrow" (click)="scrollMobileBar('left')">
    ‹
  </button>

  <!-- Scrollable Links -->
  <div #scrollContainer class="mobile-api-bar d-flex overflow-auto" (scroll)="updateScrollArrows()">
    <a *ngIf="isRestAPIEnabled" href="/doc/trade/1.2.1/getting-started/introduction" class="mobile-api-link"
      [ngClass]="activePage == 'rest-api-reference' ? 'active' : ''">Trade API</a>
    <!-- <a *ngIf="isExternalAPIEnabled" href="/external-api-reference#/035e964642eed-create-individual-investor-account"
      class="mobile-api-link" [ngClass]="activePage == 'external-api-reference#' ? 'active' : ''">BackOffice APIs</a> -->
    <a *ngIf="isEmbedAPIEnabled" href="/doc/microinvest/1.1.0/guides/getting-started" class="mobile-api-link"
      [ngClass]="activePage == 'microinvest-api' ? 'active' : ''">Microinvest API</a>
    <a *ngIf="isEmbedAPIEnabled" href="/doc/invest/1.0.0/apis/authentication/get-server-token" class="mobile-api-link"
      [ngClass]="activePage == 'invest-api' ? 'active' : ''">Invest API</a>
  </div>

  <!-- Right Scroll Button -->
  <button class="scroll-btn right" *ngIf="showRightArrow" (click)="scrollMobileBar('right')">
    ›
  </button>
</div>


<div *ngIf="!isLoggedIn && userType === 'OMS'"
  class="d-flex d-lg-none justify-content-end align-items-center px-3 mobile-login-bt">
  <button type="button" (click)="login()" class="btn btn-outline ms-2 login-btn">
    Log In
  </button>
</div>